// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c294ad4","952":"b0e3c73a"}[chunkId] + ".chunk.js";
};